import React from 'react';
import { compose } from 'recompose';
import { reduxForm, getFormValues, Field } from 'redux-form';
import { connect } from 'react-redux';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { SelectInput, ModalButtons } from '../../_Components';

const EMPTY_SETTINGS = {
    activity: false,
    activity_subject: [],
    callback: false,
    create: false,
    email: false,
    emails: [],
    phones: [],
    sendCustomer: false,
    sms: false,
    telegram: false,
    telegramChats: [],
    transfer: false,
    transfer_phones: [],
};

const toOptions = (list = []) => list.map((item) => ({ id: item.value, name: item.label }));

const AddAction = ({
    open,
    close,
    save,
    results = [],
    tasks = [],
    formValues,
    change,
    copyFields,
}) => {
    const values = formValues || {};
    const selectedTask = (tasks || []).find((item) => item.value === values.task);
    const subs = (selectedTask && selectedTask.sub) || [];
    const needSub = subs.length > 0;
    const canSave = Boolean(values.result && values.task && (!needSub || values.sub_task));
    const isCopy = Boolean(copyFields);

    const handleClose = () => close(false);

    const handleSave = () => {
        if (!canSave) return;
        save(values);
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            onClose={handleClose}
            disableEnforceFocus
            disableAutoFocus
            disableRestoreFocus
            aria-labelledby="pc-addact-title"
            sx={{
                '& .MuiDialog-paper': {
                    overflow: 'visible',
                    width: 1040,
                    maxWidth: 'calc(100vw - 32px)',
                    borderRadius: '12px',
                    boxShadow: '0 24px 70px rgba(11, 32, 51, 0.32)',
                },
            }}
        >
            <DialogTitle id="pc-addact-title" component="div" sx={{ pb: 0.5 }}>
                {isCopy ? 'Дублировать действие' : 'Новое действие'}
                <div style={{
                    marginTop: 4,
                    fontSize: 12.5,
                    fontWeight: 400,
                    color: 'var(--muted)',
                    lineHeight: 1.35,
                }}>
                    {isCopy
                        ? 'Выберите другой результат и тему — поля и обработки скопируются'
                        : 'Когда срабатывает это действие'}
                </div>
            </DialogTitle>
            <DialogContent sx={{ overflow: 'visible', pt: '16px !important', pb: 1 }}>
                <div className="pc-addact-fields">
                    <Field
                        name="result"
                        required
                        compact
                        component={SelectInput}
                        options={toOptions(results)}
                        label="Результат"
                        searchable
                        searchPlaceholder="Найти результат"
                        placeholder="Не указано"
                    />
                    <Field
                        name="task"
                        required
                        compact
                        component={SelectInput}
                        options={toOptions(tasks)}
                        label="Тема"
                        searchable
                        searchPlaceholder="Найти тему"
                        placeholder="Не указано"
                        onChange={() => change('sub_task', null)}
                    />
                    {needSub ? (
                        <Field
                            name="sub_task"
                            required
                            compact
                            component={SelectInput}
                            options={toOptions(subs)}
                            label="Подтема"
                            searchable
                            searchPlaceholder="Найти подтему"
                            placeholder="Не указано"
                        />
                    ) : null}
                </div>
                {!canSave ? (
                    <div style={{ marginTop: 12, fontSize: 12, color: 'var(--danger)' }}>
                        Заполните обязательные поля, отмеченные *
                    </div>
                ) : null}
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <ModalButtons
                    handleSaveClick={handleSave}
                    handleCloseClick={handleClose}
                    disabled={!canSave}
                />
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state, props) => {
    const copyFields = props.copyFields || {
        cols: [],
        settings: { ...EMPTY_SETTINGS },
    };
    return {
        initialValues: {
            ...copyFields,
            task: null,
            sub_task: null,
            result: null,
        },
        formValues: getFormValues('cardAddAction')(state),
    };
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'cardAddAction',
        destroyOnUnmount: true,
        enableReinitialize: true,
        forceUnregisterOnUnmount: true,
    }),
);

export default enhance(AddAction);
